import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const PlatformSettingsDataDomains = () => {
	return <PlaceholderView pageType={PageType.PlatformSettingsDataDomains} text="Data domains" />;
};

export default PlatformSettingsDataDomains;
